import NavBar from "./NavBar";
import Logo from "./Logo";
import { animationDelays } from "../../constants/styles";

const Header = () => {
  return (
    <div
      className="fixed bg-white w-screen h-fit flex flex-row justify-between px-4 py-2 md:px-16 slideFromTop z-10"
      style={animationDelays.delay1}
    >
      <Logo />
      <div className="flex flex-col justify-center">
        <NavBar />
      </div>
    </div>
  );
};

export default Header;
